/* eslint-disable react/no-array-index-key */
import Image from '@base/Image';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from '@unicons-base/Typography/Typography';
import React from 'react';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';

type ListType = {
  title: string;
  titleColor?: string;
  listIcon?: string;
};

interface ListProps {
  list: ListType[];
}

const ListWrapper = styled.div`
  padding: ${Spacings.SPACING_6B} 0;
`;

const StyledListItem = styled(Typography)`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_3B};
  }
`;

type ListItemType = {
  $color: string | null;
};

const ListItemText = styled.span<ListItemType>`
  margin-left: ${Spacings.SPACING_3B};
  color: ${({ $color }) => $color || 'var(--color-i-icon-dark-secondary)'};
`;
const List: React.FC<ListProps> = ({ list }) => {
  return (
    <ListWrapper>
      {list.map((listItem, index) => (
        <StyledListItem
          variant={UN_ICONS_TYPOGRAPHY_VARIANT.SUBTITLE2}
          key={index}
        >
          <Image
            src={listItem.listIcon || 'list-bullet.svg'}
            alt="List bullet"
            width={20}
            height={20}
            layout="intrinsic"
          />
          <ListItemText $color={listItem.titleColor}>
            {listItem.title}
          </ListItemText>
        </StyledListItem>
      ))}
    </ListWrapper>
  );
};

List.displayName = 'List';

export default List;
